import { render, staticRenderFns } from "./habitStatistic.vue?vue&type=template&id=fe099c2c&scoped=true"
import script from "./habitStatistic.vue?vue&type=script&lang=js"
export * from "./habitStatistic.vue?vue&type=script&lang=js"
import style0 from "./habitStatistic.vue?vue&type=style&index=0&id=fe099c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe099c2c",
  null
  
)

export default component.exports